export default __webpack_public_path__ + "static/media/Arkodyuti.94c8d7f4.jpg";